<template>
  <div class="not-found">
    <v-row align="center">
      <v-col sm="12" md="6">
        <img style="max-width: 100%" :src="require('@/assets/img/not-found.png')">
      </v-col>
      <v-col sm="12" md="6" class="nf-headers ">
        <h1 class="nf-h1">Oops!</h1>
        <h2 class="nf-h2">No pudimos encontrar la página que estas buscando.</h2>
        <h3 class="nf-h3 mt-3 mb-1">Error 404</h3>
        <router-link id="nf-home" to="/home">
          Regresar al inicio <v-icon id="nf-home-icon">mdi-home</v-icon>
        </router-link>
      </v-col>
    </v-row>
  </div>
</template>
<script>
  export default {
    name: 'NotFound',
    created(){
      if(!this.$msal.isAuthenticated()){
        this.$router.replace('login')
      }
    }
  }
</script>
<style lang="css" scoped>  
  @import '../assets/styles/not-found.css';
</style>